import { config } from 'lib-shared-backend-config';
class Userlane {
    install() {
        (function (i, s, o, g, r) {
            var _a;
            i['UserlaneCommandObject'] = r;
            i[r] =
                i[r] ||
                    function () {
                        // eslint-disable-next-line prefer-rest-params
                        (i[r].q = i[r].q || []).push(arguments);
                    };
            const script = s.createElement('script');
            const first = s.getElementsByTagName('script')[0];
            script.async = true;
            script.src = g;
            (_a = first === null || first === void 0 ? void 0 : first.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(script, first);
        })(window, document, 'script', 'https://cdn.userlane.com/userlane.js', 'Userlane');
    }
    loadUser(profile, organization) {
        window.Userlane('identify', profile.id, {
            name: profile.name,
            email: profile.email,
            role: profile.roles,
            organization: profile.org_id,
            subdomain: organization.subdomain,
            isInTrial: organization.trial_ended_at === null ? true : false,
            suspended: organization.suspended,
        });
    }
    initialize() {
        window.Userlane('init', config.sdk.userlane);
    }
}
export const userlaneService = new Userlane();
